export default function containsText(value: string, searchText: string): boolean {
    if (searchText == null || searchText.length === 0) return true;

    return value.toUpperCase().includes(searchText.toUpperCase());
}